export default __webpack_public_path__ + "static/media/approve-aqua.dfa9f1b3.svg";